import { getActionGridColumns } from '@/services/Action/ActionGridConfig';

const propertyActionFields = [
  'clientActionId',
  'assessmentType',
  'dueDate',
  'internalDueDate',
  'tags',
  'status',
  'lastStatusUpdatedDate',
  'reviewer',
  'currentResponsibleTeam',
  'actionType',
  'priority',
  'question',
  'category',
  'comments',
  'notes',
  'minQuantity',
  'maxQuantity',
  'recommendation',
  'specification',
  'rate',
  'minCost',
  'maxCost',
];

const columns = getActionGridColumns()
  .filter(column => propertyActionFields.includes(column.field));
const id = columns.find(column => column.field === 'clientActionId');
id.checkboxSelection = true;
id.headerCheckboxSelection = true;

export const gridColumns = columns;

export const gridDefaultColDef = {
  filter: 'agSetColumnFilter',
  filterParams: {
    selectAllOnMiniFilter: false,
  },
};
